import React from 'react';
import EditablePage from './EditablePage';
import SEO from './SEO';

/**
 * About Component - Cranford Publications History and Information
 * Author: Markus van Kempen - markus.van.kempen@gmail.com
 * Updated: Jul 2026 — stronger SEO + AboutPage / Person JSON-LD
 */

const ABOUT_TITLE =
  'About Cranford Publications | Paul Cranford - Lighthouse Keeper Fiddler';
const ABOUT_DESCRIPTION =
  '40+ years preserving Celtic fiddle music. Founded 1979 by Paul Stewart Cranford, Cape Breton fiddler and retired lighthouse keeper. Katherine McLennan Award winner.';
const BASE_URL = 'https://www.cranfordpub.ca';

const aboutJsonLd = {
  '@context': 'https://schema.org',
  '@graph': [
    {
      '@type': 'AboutPage',
      '@id': `${BASE_URL}/about#webpage`,
      url: `${BASE_URL}/about`,
      name: ABOUT_TITLE,
      description: ABOUT_DESCRIPTION,
      isPartOf: {
        '@type': 'WebSite',
        name: 'Cranford Publications',
        url: BASE_URL,
      },
      mainEntity: { '@id': `${BASE_URL}/#organization` },
    },
    {
      '@type': 'Organization',
      '@id': `${BASE_URL}/#organization`,
      name: 'Cranford Publications',
      url: BASE_URL,
      foundingDate: '1979',
      description: ABOUT_DESCRIPTION,
      email: 'cranfordpub@gmail.com',
      telephone: '+1-902-929-2391',
      address: {
        '@type': 'PostalAddress',
        addressRegion: 'Nova Scotia',
        addressCountry: 'CA',
      },
      founder: { '@id': `${BASE_URL}/about#paul-cranford` },
      logo: `${BASE_URL}/images/android-chrome-512x512.png`,
    },
    {
      '@type': 'Person',
      '@id': `${BASE_URL}/about#paul-cranford`,
      name: 'Paul Stewart Cranford',
      jobTitle: 'Fiddler, composer, and music publisher',
      description:
        'Cape Breton fiddler, composer, and retired lighthouse keeper. Founder of Cranford Publications (1979).',
      worksFor: { '@id': `${BASE_URL}/#organization` },
      address: {
        '@type': 'PostalAddress',
        addressRegion: 'Nova Scotia',
        addressCountry: 'CA',
      },
    },
  ],
};

export default function About() {
  return (
    <>
      <SEO
        title={ABOUT_TITLE}
        description={ABOUT_DESCRIPTION}
        canonical="/about"
        keywords="Paul Cranford, Cranford Publications history, Celtic music publisher, Cape Breton fiddler, lighthouse keeper musician, Katherine McLennan Award"
        jsonLd={aboutJsonLd}
      />
      <EditablePage pageId="about" pageTitle="About Us" floatingSharePath="/about" />
    </>
  );
}
